/**
 * Shared Grid Styles
 * Centralized style constants for consistent grid styling across the application.
 * Based on sessions-report grid design (HIVE-6337).
 */

export const GRID_STYLES = {
  header: {
    background: 'bg-[#F1F1F1]',
    text: 'text-[#262626]',
    hoverText: 'hover:text-[#434343]',
    cell: 'h-12 px-4 text-left align-middle text-xs font-medium',
  },
  row: {
    default: 'bg-white',
    hover: 'hover:bg-[#FAFAFA]',
    selected: 'bg-[#FFFBEB]',
    selectedHover: 'hover:bg-[#FEF8DF]',
    group: 'bg-[#F1F1F1]',
    groupHover: 'hover:bg-[#E8E8E8]',
  },
  cell: {
    base: 'p-4 align-middle',
    compact: 'px-4 py-2',
    emptyValue: '', // Empty string - no placeholder character
  },
  border: 'border-[#E8E8E8]',
  sort: {
    active: 'text-[#FFCD00]',
    inactive: 'text-gray-400',
  },
} as const;

/**
 * Empty value placeholder for grid cells
 * Returns empty string instead of dash/placeholder
 */
export const EMPTY_CELL_VALUE = '';

/**
 * Helper to get sort icon color based on current sort state
 */
export function getSortIconColor(
  column: string,
  direction: 'asc' | 'desc',
  currentColumn: string,
  currentDirection: 'asc' | 'desc' | null
): string {
  if (currentColumn === column && currentDirection === direction) {
    return GRID_STYLES.sort.active;
  }
  return GRID_STYLES.sort.inactive;
}
